import { render, staticRenderFns } from "./staffCard.vue?vue&type=template&id=77e37132&scoped=true&"
import script from "./staffCard.vue?vue&type=script&lang=js&"
export * from "./staffCard.vue?vue&type=script&lang=js&"
import style0 from "./staffCard.vue?vue&type=style&index=0&id=77e37132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e37132",
  null
  
)

export default component.exports